// Full-screen onboarding shell. Renders a progress bar, optional back
// button, title/subtitle, children content area, and a sticky CTA button.
//
// Props:
//   step        — zero-based current step index
//   total       — total number of steps
//   title       — screen heading
//   subtitle    — optional sub-heading
//   children    — screen body content
//   onNext      — called when CTA pressed
//   onBack      — optional; renders a back link when provided and step > 0
//   nextLabel   — CTA button text (default "Continue")
//   nextDisabled — boolean; greys out the CTA

import { C } from "../theme.js";
import { ProgressDots } from "./ProgressDots.jsx";

export function OnboardWrap({ step, total, title, subtitle, children, onNext, onBack, nextLabel = "Continue", nextDisabled }) {
  return (
    <div style={{
      minHeight: "100vh", background: C.cream, display: "flex",
      flexDirection: "column", alignItems: "center", padding: "0 0 100px",
    }}>
      <div style={{ width: "100%", maxWidth: 480, padding: "50px 20px 20px" }}>
        <ProgressDots step={step} total={total} />
        {onBack && step > 0 && (
          <button onClick={onBack} style={{
            background: "none", border: "none", color: C.green,
            fontWeight: 700, fontSize: 15, cursor: "pointer",
            display: "flex", alignItems: "center", gap: 4, marginBottom: 16, padding: 0,
          }}>
            ‹ Back
          </button>
        )}
        <h1 style={{
          fontFamily: "Lora, Georgia, serif", fontWeight: 700,
          fontSize: 30, color: C.charcoal, marginBottom: 8, lineHeight: 1.2,
        }}>
          {title}
        </h1>
        {subtitle && (
          <p style={{ color: C.grey, fontSize: 15, marginBottom: 24, lineHeight: 1.5 }}>
            {subtitle}
          </p>
        )}
        {children}
      </div>
      <div style={{
        position: "fixed", bottom: 0, left: 0, right: 0, padding: "16px 20px 24px",
        background: `linear-gradient(to top, ${C.cream} 70%, transparent)`,
        display: "flex", justifyContent: "center",
      }}>
        <button
          onClick={onNext}
          disabled={nextDisabled}
          style={{
            width: "100%", maxWidth: 440, padding: "16px 24px",
            borderRadius: 99, border: "none",
            background: nextDisabled ? C.border : C.green,
            color: nextDisabled ? C.grey : C.white,
            fontFamily: "inherit", fontWeight: 700, fontSize: 17,
            cursor: nextDisabled ? "not-allowed" : "pointer",
            boxShadow: nextDisabled ? "none" : C.shMd,
            transition: "all .2s",
          }}
        >
          {nextLabel}
        </button>
      </div>
    </div>
  );
}
